/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

// import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import ToolBar from "@mui/material/Toolbar";
import AppNotifications from "../../../Cloud/Benachrichtigungen/Components/AppNotifications";
import AppAccount from "../../../Management/Mandanten/Components/AppAccount";
import AppHelp from "../../../Management/Support/Components/AppHelp";
import { useAppContext } from "../AppContext";
import AppMenu from "../AppMenu";
import { useAppRollenContext } from "../AppRollenContext";
import AppTitle from "../AppTitle";
import "./AppHeader.scss";

export default function AppHeader() {
    const appContext = useAppContext();
    const appRollenContext = useAppRollenContext();
    return (
        <>
            {appContext.zeigeAppHeader &&
                <AppBar className="lan-appheader" position="static">
                    <ToolBar className="lan-appheader__toolbar">
                        {appRollenContext.istNutzend && <AppMenu />}
                        <AppTitle />
                        <AppHelp />
                        {appRollenContext.istNutzend && <AppNotifications />}
                        {appRollenContext.istNutzend && <AppAccount />}
                    </ToolBar>
                </AppBar>
            }
        </>
    );
}
